import { FC } from "react";

import { FormStep } from "../steps";

import { RenderLabel } from "./RenderLabel";
import { INPUT_CLASSNAME } from "./constants";

export type InputFormElementProps = {
  value: string | boolean | number;
  setValue: (value: string | boolean) => void;
  currentStep: FormStep;
};

export const InputFormElement: FC<InputFormElementProps> = ({
  value,
  setValue,
  currentStep,
}) => {
  const {
    name: identifier,
    title,
    type,
    required,
    showStar,
    autocomplete,
  } = currentStep;

  const isCheckbox = type === "checkbox";

  const stringValue = value.toString();
  const inputValue = type === "url" && !stringValue ? "https://" : stringValue;

  return (
    <div className={isCheckbox ? "mb-4 flex gap-x-3" : ""}>
      <RenderLabel
        identifier={identifier}
        title={title}
        required={required}
        showStar={showStar}
      />

      <input
        autoComplete={autocomplete ?? identifier}
        id={identifier}
        className={isCheckbox ? "" : INPUT_CLASSNAME}
        type={type}
        value={inputValue}
        onChange={({ target }) =>
          setValue(isCheckbox ? target.checked : target.value)
        }
        required={required}
      />
    </div>
  );
};
